import {useQuery} from '@tanstack/react-query';

import {GetListOutput, QueryOptionsForList} from '@shared/api';
import {getReports, GetReportsParams} from '../api';
import {QUERY__REPORTS} from '../queryKeys';
import {UserReport} from '../types';

export const useGetReports = <SelectedData = GetListOutput<UserReport>>(
  params?: GetReportsParams,
  options?: QueryOptionsForList<UserReport, SelectedData>,
) => {
  return useQuery({
    queryKey: [QUERY__REPORTS, params],
    queryFn: () => getReports(params),
    ...options,
  });
};
